import { useMemo, useCallback } from "react";

import { useCookies } from "react-cookie";
import ENVIRONMENT_VAR from "@/shared/models/environment/environments.var";
import dayjs from "dayjs";
import { IMaxcoreDataSession } from "@/shared/services/qrtk/auth/adapters/maxcore-old-user.adapter";

const COOKIE_EXPIRES = 15; // 15 days
const configCookie: any = {
  domain: ENVIRONMENT_VAR.COOKIE_DOMAIN,
  expires: dayjs().add(COOKIE_EXPIRES, "day").toDate(),
  sameSite: "none",
  secure: true,
  path: "/"
};

function useCookieSessionManager() {
  const { COOKIE_DATA, COOKIE_TOKEN } = ENVIRONMENT_VAR;
  const [cookies, setCookie, removeCookie] = useCookies();

  const state = useMemo(() => {
    return {
      token: cookies[COOKIE_TOKEN] || "",
      data: cookies[COOKIE_DATA] || ""
    };
  }, [JSON.stringify(cookies)]);

  const removeSessionFromCookie = useCallback(() => {
    removeCookie(COOKIE_TOKEN, configCookie);
    removeCookie(COOKIE_DATA, configCookie);
  }, [removeCookie, COOKIE_TOKEN, COOKIE_DATA]);

  const setSessionDataUserFormMaxcorev1 = useCallback(
    (data: IMaxcoreDataSession) => {
      const values = JSON.stringify({ ...data });
      setCookie(COOKIE_DATA, values, configCookie);
    },
    [setCookie, COOKIE_DATA]
  );

  const setSessionTokenUser = useCallback(
    (data: ISessionData) => {
      const values = JSON.stringify({ ...data });
      setCookie(COOKIE_TOKEN, values, configCookie);
    },
    [setCookie, COOKIE_TOKEN]
  );

  return {
    removeSessionFromCookie,
    setSessionDataUserFormMaxcorev1,
    setSessionTokenUser,
    ...state
  };
}
export default useCookieSessionManager;

export interface ISessionData {
  token: string;
  maxCoreTokenV1: string;
}
